import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPatient = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.5385 9.41177C16.8979 9.41177 18 10.4652 18 11.7647v7.0588C18 19.4733 17.449 20 16.7692 20h-1.2307v-5.2941c0-.3249-.2756-.5883-.6154-.5883-.3399 0-.6154.2634-.6154.5883V20H5.69231v-5.2941c0-.3249-.27552-.5883-.61539-.5883-.33986 0-.61538.2634-.61538.5883V20H3.23077C2.55103 20 2 19.4733 2 18.8235v-7.0588c0-1.2995 1.10207-2.35293 2.46154-2.35293H15.5385Zm-1.2308-5.29412c0 2.27411-1.9286 4.11764-4.3077 4.11764-2.37907 0-4.30769-1.84353-4.30769-4.11764C5.69231 1.84353 7.62093 0 10 0c2.3791 0 4.3077 1.84353 4.3077 4.11765Z" })
});
export default SvgPatient;
